export default {
  title: 'Passerelle de paiement',
  description:
    'Vos propres passerelles de paiement pour les commandes en ligne. Le montant total de la commande est réglé sur votre compte de passerelle ; vous réglez ensuite avec vos restaurants.',
  toasts: {
    load_error: 'Échec du chargement de la configuration de la passerelle',
  },
  not_enabled: {
    title: "Spreedly n'est pas encore activé pour votre compte",
    description:
      'Les passerelles de paiement locales sont activées par FoodAmigos. Veuillez contacter votre représentant FoodAmigos pour commencer.',
  },
  processor_mode: {
    title: 'Qui traite les paiements ?',
    description:
      "Ce choix s'applique une fois pour tous vos restaurants. Vous pourrez le modifier plus tard dans les paramètres Partenaire tant qu'aucun restaurant n'est actif.",
    save: 'Enregistrer',
    options: {
      platform: {
        title: 'FoodAmigos traite les paiements',
        badge: 'Recommandé',
        description:
          'Nous gérons le compte de paiement, la vérification et les versements. Chaque restaurant ajoute ses informations professionnelles et complète une courte vérification avec Adyen.',
        methods: 'Acceptés : {{methods}}',
      },
      provider: {
        title: "J'utilise mon propre prestataire",
        description:
          'Connectez un prestataire de paiement que vous utilisez déjà. Les versements, frais et vérifications restent gérés par lui.',
      },
    },
    payment_methods: {
      card: 'Carte',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      pay_by_bank: 'Paiement par virement bancaire',
      giropay: 'giropay',
      sepa_debit: 'SEPA',
    },
    locked: {
      platform: 'FoodAmigos traite les paiements pour tous vos restaurants.',
      provider: 'Vos restaurants prennent les paiements via vos propres prestataires.',
    },
    confirm_choice: {
      title: 'Définir les paiements sur « {{mode}} » ?',
      description:
        "Cela s'applique à tous les restaurants que vous gérez. Vous pourrez changer plus tard dans les paramètres Partenaire, mais uniquement tant qu'aucun restaurant n'est actif.",
      confirm: 'Enregistrer et continuer',
    },
    switch: {
      link: 'Modifier le mode de traitement des paiements',
      confirm: {
        confirm: 'Changer',
        provider: {
          title: 'Passer à votre propre prestataire ?',
          description: 'Les restaurants utilisant les paiements FoodAmigos repasseront à Non configuré.',
        },
        platform: {
          title: 'Passer aux paiements FoodAmigos ?',
          description: 'Les restaurants utilisant vos propres prestataires repasseront à Non configuré.',
        },
      },
      unavailable: {
        title: 'Les paiements FoodAmigos ne sont pas encore disponibles',
        description: 'Les paiements FoodAmigos ne sont pas encore disponibles dans votre pays.',
        confirm: 'OK',
      },
      blocked: {
        title: 'Contactez FoodAmigos pour modifier ceci',
        description_one:
          "{{count}} restaurant traite des paiements en direct. Changer signifierait qu'il doit se réinscrire auprès du nouveau prestataire. Notre équipe planifiera cela avec vous.",
        description_other:
          "{{count}} restaurants effectuent des paiements en direct. Changer signifierait qu'ils devraient se réinscrire auprès du nouveau prestataire. Notre équipe planifiera cela avec vous.",
        confirm: 'Envoyer un e-mail à FoodAmigos',
        subject_one: 'Changer le mode de traitement des paiements ({{count}} restaurant en direct)',
        subject_other: 'Modifier le mode de traitement des paiements ({{count}} restaurants actifs)',
      },
    },
    toasts: {
      load_error: 'Échec du chargement de la configuration des paiements',
      save_error: "Échec de l'enregistrement de la configuration des paiements",
      chosen: 'Traitement des paiements enregistré',
      switched: 'Traitement des paiements modifié',
    },
  },
  gateways: {
    title: 'Fournisseurs connectés',
    empty:
      'Connectez le fournisseur de paiement que vous utilisez déjà. Vos restaurants seront intégrés sous celui-ci.',
    connect_another: 'Connecter un fournisseur',
    support_hint:
      "Une fois qu'un restaurant accepte des paiements en direct, changer son fournisseur se planifie avec nous — écrivez à {{email}}.",
    kinds: {
      stripe_connect: 'Stripe Connect',
      spreedly: 'Passerelle de paiement',
      platform_adyen: 'Paiements FoodAmigos',
    },
    statuses: {
      connected: 'Connecté',
      disconnected: 'Déconnecté',
      needs_attention: 'À traiter',
    },
    issue: {
      connect_not_enabled: {
        title: 'Stripe Connect n’est pas activé sur le compte associé à {{name}}',
        description:
          'Stripe ne peut pas créer de comptes pour vos restaurants tant que Connect n’est pas activé. Activez-le dans votre tableau de bord Stripe, puis revérifiez ici.',
      },
      account_restricted: {
        title: 'Stripe bloque les nouveaux comptes sous {{name}}',
        description:
          'Stripe a temporairement restreint votre compte pour la création de comptes connectés. Connectez-vous à votre tableau de bord Stripe, confirmez que vous souhaitiez créer ces comptes, puis revérifiez ici.',
      },
      loss_liability_unaccepted: {
        title: 'Stripe exige que {{name}} accepte d’abord la responsabilité des pertes',
        description:
          'Votre plateforme Stripe n’a pas encore accepté la responsabilité des soldes négatifs sur les comptes de vos restaurants ; Stripe ne les créera donc pas. Dans votre tableau de bord Stripe, ouvrez Paramètres → Connect → Profil de la plateforme et validez la reconnaissance de responsabilité des pertes, puis revérifiez ici. Vous pouvez ignorer la remarque de Stripe sur les comptes v2 ci-dessous.',
      },
      account_creation_refused: {
        title: 'Stripe a refusé de créer un compte restaurant sous {{name}}',
        description: 'Consultez le message ci-dessous dans votre tableau de bord Stripe, puis revérifiez ici.',
      },
      key_invalid: {
        title: "Stripe n'accepte plus la clé que vous avez connectée pour {{name}}",
        description:
          'La clé a été renouvelée, révoquée ou a expiré. Créez une nouvelle clé dans votre Stripe Dashboard, puis remplacez-la ici.',
      },
      key_access_limited: {
        title: 'Stripe a limité la clé connectée pour {{name}}',
        description:
          'Une clé limitée ne peut pas créer de transferts ni de virements pour vos restaurants. Dans votre tableau de bord Stripe, ouvrez Développeurs → Clés API et rétablissez l’accès complet de la clé, puis vérifiez à nouveau ici — ou renouvelez la clé et remplacez-la ici.',
      },
      provider_said: 'Réponse de Stripe : « {{message}} »',
      hint: 'Tant que ce problème n’est pas résolu, les restaurants liés à ce prestataire ne peuvent pas commencer à accepter les paiements en ligne.',
      open_stripe: 'Ouvrir le tableau de bord Stripe',
      check_again: 'Revérifier',
      replace_key: 'Remplacer la clé',
      cleared: 'Stripe accepte à nouveau vos restaurants',
      still_blocked: 'Stripe refuse toujours — voir sa réponse ci-dessus',
    },
    refused: {
      provider_said: "Ce qu'a dit {{name}} : « {{message}} »",
      reference: 'Référence :',
      contact_support: 'Contacter le support par e-mail',
      support_subject: 'Connexion du prestataire de paiement refusée : {{name}} (réf. {{reference}})',
      account_in_test_mode: {
        action: 'Désactivez le mode test dans Authorize.Net, sous {{path}}, puis réessayez.',
        open: 'Ouvrir Authorize.Net',
      },
      processor_not_configured: {
        action:
          "Appelez votre prestataire de services marchands, l'entreprise qui a ouvert votre compte Authorize.Net, et demandez-leur de terminer sa configuration avec son processeur de paiement. De nouvelles clés ne changeront rien. Réessayez ensuite.",
        action_card_connect:
          "Demandez au support CardConnect d'activer les autorisations sans carte présente (e-commerce) pour cet identifiant marchand. De nouveaux identifiants API n'y changeront rien. Réessayez ensuite.",
      },
    },
    table: {
      primary_tag: 'Par défaut',
      live_count_one: '{{count}} acceptent des paiements',
      live_count_other: '{{count}} acceptent des paiements',
      attention_count_one: '{{count}} nécessite une attention',
      attention_count_other: '{{count}} nécessitent une attention',
      columns: {
        connection: 'Fournisseur',
        status: 'Statut',
        restaurants: 'Restaurants',
        methods: 'Méthodes locales',
      },
      methods_count: '{{enabled}} sur {{capable}} activées',
    },
    picker: {
      recommended: 'Recommandé',
      connect: 'Connecter',
      stripe_connect: {
        title: 'Stripe Connect',
        description:
          "Utilisez votre propre compte Stripe. Chaque restaurant effectue l'intégration Stripe elle-même ; les paiements et frais restent gérés par Stripe.",
        already_connected: 'Déjà connecté. Utilisez « Modifier les identifiants » dans la liste pour remplacer sa clé.',
        already_connected_short: 'Déjà connecté.',
      },
      stripe_direct: {
        title: 'Stripe (direct)',
        description: 'Facturez chaque restaurant via un seul de vos comptes Stripe.',
        unavailable: 'Pas encore disponible dans votre région.',
      },
      paypal: {
        direct: 'Proposez PayPal depuis votre propre compte professionnel PayPal.',
        braintree: 'Acceptez les cartes, PayPal et Venmo via votre compte Braintree.',
      },
      other: {
        title: 'Autres fournisseurs',
        search: 'Rechercher des fournisseurs',
        loading: 'Chargement des fournisseurs…',
        no_match: 'Aucun fournisseur nommé « {{query}} ».',
        none_available: "Aucun autre fournisseur n'est encore disponible dans votre région.",
        load_error: "La liste des fournisseurs n'a pas pu être chargée.",
        retry: 'Réessayer',
        pinned_match: 'Ce fournisseur est épinglé ci-dessus.',
      },
      not_listed: {
        action: "Mon fournisseur n'est pas répertorié",
        subject: 'Demande de fournisseur de paiement : {{query}}',
      },
      use_foodamigos: {
        no_account: "Je n'ai de compte chez aucun d'entre eux",
        switch: 'Passer aux paiements FoodAmigos',
      },
    },
    orchestrated: {
      title: 'Connecter {{name}}',
      replace_title: 'Remplacer les identifiants de {{name}}',
      intro:
        'Saisissez les identifiants de votre compte {{name}}. Nous les vérifions auprès de {{name}} avant tout enregistrement.',
      auth_mode: 'Comment vous vous connectez à ce fournisseur',
      checking: 'Vérification auprès de {{name}}…',
      paypal_direct: {
        intro:
          "Collez l'ID client et le secret de l'application REST PayPal via laquelle vos restaurants doivent accepter PayPal. Nous les vérifions auprès de PayPal avant tout enregistrement.",
        client_id: 'ID client',
        secret: 'Secret',
        hint: 'Tableau de bord développeur PayPal → Applications et identifiants, onglet Live. Utilisez une application REST de votre compte professionnel.',
        hint_sandbox:
          "Tableau de bord des développeurs PayPal → Applications et identifiants, onglet Sandbox : cet environnement n'accepte que les applications sandbox.",
      },
      braintree: {
        intro:
          'Saisissez les clés API de votre compte Braintree. PayPal et Venmo fonctionnent une fois liés dans votre panneau de configuration Braintree — vous les activez ensuite par connexion.',
      },
      authorize_net: {
        intro:
          "Saisissez l'ID de connexion API et la clé de transaction de votre compte Authorize.Net. Nous les vérifions avec une petite autorisation test : votre journal de transactions Authorize.Net l'affichera comme un refus de 1,00 $, sans aucun mouvement d'argent. Le compte doit être en mode réel, car en mode test Authorize.Net refuse tout paiement réel.",
        hint: "Vous trouverez les deux dans l'interface marchande Authorize.Net, sous {{path}}.",
      },
      card_connect: {
        intro:
          "Saisissez l'identifiant marchand, le nom d'utilisateur et le mot de passe de votre compte CardConnect (CardPointe) en production. Nous les vérifions par une autorisation de 1,00 que nous annulons aussitôt : votre journal de transactions CardPointe l'affiche comme un 1,00 refusé ou annulé, et aucun argent n'est prélevé.",
      },
      stripe_direct: {
        intro:
          'Collez la clé secrète ou une clé restreinte du compte Stripe via lequel chaque restaurant doit encaisser. Nous configurons pour vous le webhook dont Stripe a besoin.',
        secret_key: 'Clé secrète ou restreinte Stripe',
        hint: "Stripe → Développeurs → Clés API. Commence par sk_ (secrète) ou rk_ (restreinte). Une clé restreinte nécessite l'accès en écriture à Charges et remboursements, Clients, PaymentIntents, PaymentMethods, SetupIntents, Tokens et Endpoints de webhook. Aucune clé publiable n'est nécessaire.",
        prefix_error: 'Les clés secrètes Stripe commencent par sk_, les clés restreintes par rk_.',
      },
      connected: {
        title: '{{name}} est connecté.',
        description:
          'Nous utiliserons ces identifiants pour tous vos restaurants. Chaque restaurant ajoute tout de même ses informations professionnelles.',
      },
      errors: {
        generic: "Nous n'avons pas pu connecter {{name}}",
      },
    },
    stripe: {
      title: 'Connecter Stripe Connect',
      rotate_title: 'Remplacer votre clé Stripe Connect',
      rotate_intro:
        'Collez une nouvelle clé secrète et une clé publiable du même compte Stripe. Vos restaurants restent connectés.',
      intro:
        'Collez la clé secrète et la clé publiable de votre compte Stripe. Les deux se trouvent sous Developers → API keys.',
      verify_and_connect: 'Vérifier et connecter',
      checking: 'Vérification auprès de Stripe…',
      secret_key: {
        label: 'Clé secrète',
        hint: 'Stripe → Developers → API keys. Commence par sk_.',
        prefix_error: 'Les clés secrètes commencent par sk_. Cela ressemble à un autre type de clé.',
      },
      restricted_key: {
        label: 'Clé API restreinte',
        hint: 'Stripe → Développeurs → Clés API → Créer une clé restreinte. Commence par rk_. Configurez-la comme décrit ci-dessus.',
        prefix_error: 'Les clés restreintes commencent par rk_. Ceci ressemble à un autre type de clé.',
      },
      use_restricted_key: 'Utiliser une clé restreinte à la place',
      use_secret_key: 'Utiliser la clé secrète à la place',
      publishable_key: {
        label: 'Clé publiable',
        hint: 'Sur la même page Stripe. Commence par pk_. Vos boutiques en ligne en ont besoin pour accepter les cartes.',
        prefix_error: 'Les clés publiables commencent par pk_.',
        mode_mismatch:
          "L'une des clés est en mode réel et l'autre en mode test. Les deux doivent provenir du même mode Stripe.",
      },
      name: {
        label: 'Nommez cette connexion',
        hint: 'Facultatif. Affiché partout où ce fournisseur est listé.',
        placeholder: 'Stripe Connect',
      },
      permissions: {
        title: 'Comment créer cette clé',
        start_blank:
          'Lorsque Stripe demande comment vous utiliserez la clé, choisissez « {{option}} ». Toutes les autorisations sont initialement définies sur {{none}}.',
        intro:
          'Réglez ensuite le commutateur de chacune de ces lignes de section. Il définit toutes les autorisations de la section, inutile donc de les parcourir une par une.',
        rows_checked: 'Nous vérifions : {{rows}}',
        secret_key_hint:
          'Laissez toutes les autres sections sur {{none}}. Une clé secrète n’a besoin d’aucune d’entre elles.',
        open_stripe: 'Ouvrir vos clés API Stripe',
      },
      login_setting: {
        title: 'Désactivez la connexion Stripe pour vos restaurants',
        description:
          'Dans votre tableau de bord Stripe, ouvrez Paramètres → Connect → Virements → Comptes externes et désactivez « {{setting}} ». Tant qu’il est activé, Stripe oblige chaque restaurant à créer un identifiant Stripe avec un numéro de téléphone lors de l’inscription, puis demande un code SMS à chaque visite suivante ; toute personne ne disposant pas de ce téléphone ne peut pas continuer.',
        bank_details:
          'Rien n’est perdu : les restaurants saisissent leurs coordonnées bancaires dans notre propre formulaire.',
        open_stripe: 'Ouvrir ce paramètre Stripe',
      },
      errors: {
        generic: 'Impossible de joindre Stripe',
      },
    },
    default_choice: {
      label: 'Utiliser par défaut pour les restaurants',
      hint: "Les nouveaux restaurants, ainsi que ceux qui n'ont pas encore de prestataire, y sont rattachés automatiquement. Laissez la case décochée pour choisir vous-même un prestataire pour chaque restaurant.",
    },
    manage: {
      payment_methods: 'Méthodes de paiement',
      edit_credentials: 'Modifier les identifiants',
      edit_credentials_unavailable: "Modifier les identifiants (ce fournisseur n'est pas proposé actuellement)",
      set_primary: 'Définir par défaut pour les nouveaux restaurants',
      clear_primary: 'Ne plus utiliser par défaut pour les nouveaux restaurants',
      rename: {
        action: 'Renommer la connexion',
        title: 'Renommer cette connexion',
        confirm: 'Enregistrer',
      },
      disconnect: {
        action: 'Déconnecter',
        title: 'Déconnecter {{name}} ?',
        confirm: 'Déconnecter',
        warning_one: '{{count}} restaurant y est lié et repassera à Non configuré.',
        warning_other: '{{count}} restaurants y sont liés et repasseront à Non configuré.',
        live: {
          title_one: 'Les paiements en ligne sont suspendus pour {{count}} restaurant en service',
          title_other: 'Les paiements en ligne sont suspendus pour {{count}} restaurants en service',
          description:
            "Dès la déconnexion, leurs clients ne peuvent plus payer en ligne. Chaque restaurant repasse à « Non configuré » jusqu'à ce que vous le rattachiez à un autre prestataire.",
          refunds: 'Les commandes déjà payées via ce prestataire ne peuvent plus être remboursées depuis FoodAmigos.',
          pause_one: 'Suspendre les paiements en ligne pour ce restaurant',
          pause_other: 'Suspendre les paiements en ligne pour ces {{count}} restaurants',
          confirm: 'Déconnecter et suspendre les paiements',
        },
      },
      remove: {
        action: 'Retirer de la liste',
        title: 'Retirer {{name}} ?',
        description: "Il est déjà déconnecté et aucun restaurant ne l'utilise. Il n'apparaîtra plus dans cette liste.",
        confirm: 'Retirer',
      },
    },
    payment_methods: {
      title: 'Méthodes de paiement pour {{name}}',
      description:
        "Choisissez les méthodes locales que vos restaurants proposent via ce fournisseur. Chacune s'affiche uniquement si la devise du restaurant correspond.",
      save: 'Enregistrer',
      publishable_key: {
        label: 'Clé publique Stripe',
        hint: 'Stripe en a besoin pour afficher le formulaire de paiement. Trouvez-la dans votre tableau de bord Stripe sous Développeurs → Clés API.',
        invalid: 'Une clé publiable ici commence par {{prefix}}.',
        clear_to_save:
          'Il appartient à l’autre mode de Stripe. Effacez-le pour enregistrer avec toutes les méthodes locales désactivées.',
      },
      on_other_connection: 'déjà activé pour {{connection}}',
      other_currency: 'non proposé en {{currency}}',
      delivery_only: "{{name}} (commandes en livraison uniquement — l'adresse du client est requise)",
      invite_only:
        "{{name}} (Stripe l'offre uniquement sur invitation — demandez l'accès depuis votre tableau de bord Stripe, sinon Stripe refusera chaque paiement)",
      also_enable: {
        stripe:
          'Activez les mêmes méthodes dans votre tableau de bord Stripe sous Paramètres → Méthodes de paiement, sinon Stripe les refuse.',
        provider: 'Votre contrat avec ce fournisseur doit inclure les méthodes que vous activez ici.',
        braintree:
          "Liez d'abord PayPal et Venmo dans votre panneau de configuration Braintree sous Paramètres → Traitement, sinon Braintree les refuse. Venmo est réservé aux restaurants américains facturant en dollars.",
        paypal_direct:
          'Les paiements PayPal sont versés sur ce compte professionnel PayPal. Pour Venmo, connectez Braintree.',
      },
    },
    actions: {
      cancel: 'Annuler',
    },
    toasts: {
      load_error: 'Échec du chargement de vos fournisseurs connectés',
      credentials_replaced: 'Identifiants remplacés',
      save_error: "Échec de l'enregistrement",
      connected: 'Stripe Connect est connecté',
      renamed: 'Connexion renommée',
      primary_set: 'Fournisseur par défaut mis à jour',
      primary_cleared:
        "Fournisseur par défaut supprimé. Les nouveaux restaurants ne sont liés à aucun fournisseur tant que vous n'en choisissez pas un.",
      disconnected: 'Fournisseur déconnecté',
      removed: 'Prestataire retiré',
      payment_methods_saved: 'Méthodes de paiement enregistrées',
    },
  },
  restaurants: {
    title: 'Restaurants',
    description: "L'état des paiements en ligne pour chaque restaurant.",
    search: 'Rechercher des restaurants',
    filters: {
      all: 'Tous ({{count}})',
      needs_attention: 'Nécessite une attention ({{count}})',
    },
    empty: 'Aucun restaurant pour le moment.',
    empty_attention: 'Rien ne nécessite votre attention.',
    columns: {
      restaurant: 'Restaurant',
      provider: 'Fournisseur',
      status: 'Statut',
      action: 'Action',
    },
    no_provider: '—',
    foodamigos_payments: 'Paiements FoodAmigos',
    groups: {
      not_set_up: 'Non configuré',
      business_details_missing: "Détails de l'entreprise manquants",
      hosted_not_finished: 'Formulaire {{provider}} non terminé',
      hosted_not_finished_generic: 'Formulaire du prestataire non terminé',
      waiting_for_provider: 'En attente du prestataire',
      action_needed: 'Action requise',
      payments_live: 'Paiements actifs',
      online_payments_off: 'Paiements en ligne désactivés',
      waiting_for_partner: 'En attente de votre action',
    },
    link_expired: 'Lien expiré',
    actions: {
      set_up: 'Configurer',
      change: 'Modifier',
      unlink: 'Dissocier',
      remind: 'Relancer le propriétaire',
      reminded: 'Relancé · à nouveau {{time}}',
      start_over: 'Recommencer la configuration Stripe',
    },
    assign: {
      title: 'Quel prestataire {{name}} doit-il utiliser ?',
      label: 'Fournisseur',
      confirm: 'Enregistrer',
      cancel: 'Annuler',
      primary: 'Par défaut',
      none: "Connectez d'abord un prestataire.",
    },
    unlink: {
      title: 'Dissocier {{name}} de {{provider}} ?',
      title_generic: 'Dissocier {{name}} de son fournisseur ?',
      description:
        'Le restaurant repasse à « Non configuré », ce qui vous permet de choisir le bon prestataire. Le prestataire reste connecté pour vos autres restaurants.',
      confirm: 'Dissocier',
    },
    pause: {
      title: 'Les paiements en ligne sont suspendus pour {{name}}',
      description:
        "Ses clients ne peuvent plus payer en ligne tant que le restaurant n'est pas de nouveau configuré et vérifié auprès d'un prestataire.",
      refunds:
        'Les commandes déjà payées via le prestataire actuel ne peuvent plus être remboursées depuis FoodAmigos.',
      confirm: 'Suspendre les paiements en ligne pour ce restaurant',
    },
    start_over: {
      title: 'Recommencer la configuration Stripe de {{name}} ?',
      points: {
        not_used: 'Son compte Stripe actuel ({{account}}) ne sera plus utilisé pour ce restaurant.',
        kept: 'Le compte n’est pas supprimé : il reste dans votre Stripe, où vous pouvez le rejeter.',
        fresh:
          'Le prochain « Continuer » repart de la première page de Stripe, et une autre adresse e-mail peut être utilisée.',
        paused:
          'Si le restaurant accepte les paiements en ligne, ils sont suspendus jusqu’à la fin de la nouvelle configuration.',
      },
      confirm: 'Recommencer',
      blocked: {
        received_payments:
          'Le compte Stripe de ce restaurant a reçu des paiements, sa configuration ne peut donc pas être recommencée. Contactez le support pour la modifier.',
        partner_action_needed: 'Corrigez d’abord le problème affiché sur votre Stripe Connect.',
      },
    },
    toasts: {
      load_error: 'Échec du chargement de vos restaurants',
      assigned: 'Prestataire enregistré',
      assign_error: "Échec de l'enregistrement du prestataire",
      unlinked: 'Restaurant dissocié',
      unlink_error: 'Échec de la dissociation du restaurant',
      reminded: 'Rappel envoyé au propriétaire',
      remind_error: "Échec de l'envoi du rappel",
      cooling_down: "Le propriétaire a déjà été relancé aujourd'hui",
      started_over: 'Configuration Stripe recommencée',
      start_over_error: 'Échec de la reprise de la configuration Stripe',
    },
  },
  footer: {
    text: 'Vos frais de service FoodAmigos vous sont facturés quel que soit le prestataire utilisé par un restaurant.',
    link: 'Voir la facturation',
  },
};
